/** @module csi/widget/_svg/CropModePoints */
define([
	"dijit/form/ToggleButton",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(ToggleButton,_Plugin,PluginFactory,util) {

	return PluginFactory.declare([ToggleButton,_Plugin], {
		"class": "csi-button-toggle csi-single-toggle",
		bHideWhenDisabled: true,
		iconClass: "csiActionIcon svgIconPoints",
		pluginName: "CropPoints",
		title: "CanvasEditPoints",

		/**
		 * Only allow if this is edit mode for selected shape
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			this.set('checked', this.editor.isEditCustomCrop());

			if (shapes && shapes.length === 1) {
				var shape = shapes[0];

				return shape.isPicture && !this.editor.canvasApp.selection.isSelectedShapeRounded();
			}

			return false;
		},

		/**
		 * Edit selected page object.
		 */
		onClick: function() {
			this.editor.canvasApp.pageApi().changeShapeType("custom");
			this.editor.editPointsPageObject();
		}
	});
});
